import { MprcConfirmDialog, MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { enqueueSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { LmsPaths } from 'routes/LmsRouter';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    open: boolean;
    enrollmentId: string;
    onAction: (status: "canceling" | "canceled" | null) => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const DoCancelEnrollment: React.FC<IProps> = ({ open, enrollmentId, onAction }) => {

    const api = useCoreApi();
    const navigate = useNavigate();
    const { t } = useTranslation("lms");

    const [saving, setSaving] = useState<boolean>(false);

    const confirmCancel = () => {
        setSaving(true);
        onAction("canceling");
        api.v1.enrollment.cancelEnrollment({ enrollmentId })
            .then(response => {
                if (response.data === true) {
                    enqueueSnackbar(t("Student.EnrollmentView.CancelEnrolmentSuccessMessage"), { variant: "success" });
                    navigate(LmsPaths.Home);
                    onAction("canceled");
                }
                else {
                    enqueueSnackbar(t("Student.EnrollmentView.CancelEnrolmentErrorMessage"), { variant: "error" });
                }
            })
            .catch(e => MprcRequestSnackbarErrorReport(e))
            .finally(() => {
                setSaving(false);
            });
    }

    return <>
        <MprcRequestIndicator visible={saving} type="post" message={t("Student.EnrollmentView.CancelingText")} />
        <MprcConfirmDialog
            open={open && !saving}
            severity="danger"
            message={t("Student.EnrollmentView.ConfirmCancelMessage")}
            onClose={yes => {
                if (yes) {
                    confirmCancel();
                }
                else {
                    onAction(null);
                }
            }}
        />
    </>;
}

